import actionTypes from '../actions/roomPrice/actionType';

const initialState = {
  roomListLoading: false,
  allRoomList: [],
  checkInRoomList: [],
  resvRoomList: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_ROOM_LIST_LOADING:
      const { roomListLoading } = payload;
      return {
        ...state,
        roomListLoading,
      };
    case actionTypes.UPDATE_ROOM_LIST:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.UPDATE_ROOM_LIST_SORT:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.INIT_CHECKIN_ROOM_LIST:
      const { checkInRoomList } = payload;
      return {
        ...state,
        checkInRoomList,
      };

    case actionTypes.INIT_RESERVATION_ROOM_LIST:
      const { resvRoomList } = payload;
      return {
        ...state,
        resvRoomList,
      };
    default:
      return state;
  }
};
